"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var row_exports = {};
__export(row_exports, {
  rowApiConfig: () => rowApiConfig
});
module.exports = __toCommonJS(row_exports);
const rowApiConfig = {
  local: {
    iam: "https://cloud-iam-sandbox-boe.byted.org",
    page: "https://cloud-page-boe.byted.org",
    openapi: "https://cloud-openapi-boe.byted.org",
    galaxy: "https://galaxy-api-boe.byted.org",
    jwt: "https://cloud-sandbox.bytedance.net/auth/api",
    bytetree: "https://galaxy-api-sandbox.bytedance.net",
    api: "https://cloud-svc-boe.byted.org",
    bpm: "https://bpm-boe.bytedance.net",
    event: "https://cloud-page-boe.byted.org"
  },
  sandbox: {
    iam: "https://cloud-iam-sandbox-boe.byted.org",
    page: "https://cloud-page-boe.byted.org",
    openapi: "https://cloud-openapi-boe.byted.org",
    galaxy: "https://galaxy-api-boe.byted.org",
    jwt: "https://cloud-sandbox.bytedance.net/auth/api",
    bytetree: "https://galaxy-api-sandbox.bytedance.net",
    api: "https://cloud-svc-boe.byted.org",
    bpm: "https://bpm-boe.bytedance.net",
    event: "https://cloud-page-boe.byted.org"
  },
  boe: {
    iam: "https://cloud-iam.bytedance.net",
    page: "https://cloud-page.bytedance.net",
    openapi: "https://cloud-openapi.bytedance.net",
    galaxy: "https://galaxy-api.bytedance.net",
    jwt: "https://cloud-boe.bytedance.net/auth/api",
    bytetree: "https://galaxy-api.bytedance.net",
    api: "https://cloud-api.bytedance.net",
    bpm: "https://bpm-boe.bytedance.net",
    event: "https://cloud-openapi-boe.bytedance.net"
  },
  online: {
    iam: "https://cloud-iam.bytedance.net",
    page: "https://cloud-page.bytedance.net",
    openapi: "https://cloud-openapi.bytedance.net",
    galaxy: "https://galaxy-api.bytedance.net",
    jwt: "https://cloud.bytedance.net/auth/api",
    bytetree: "https://galaxy-api.bytedance.net",
    api: "https://cloud-api.bytedance.net",
    bpm: "https://bpm.bytedance.net",
    event: "https://cloud-page.bytedance.net"
  },
  pd: {
    iam: "https://cloud-pd.bytedance.net/api/v1/iam",
    page: "https://cloud-pd.bytedance.net/api/v1/cloud",
    openapi: "https://cloud-pd.bytedance.net/api/v1/cloud",
    galaxy: "https://cloud-pd.bytedance.net/api/v1/bytetree",
    jwt: "https://cloud-pd.bytedance.net/auth/api",
    bytetree: "https://cloud-pd.bytedance.net/api/v1/bytetree",
    api: "https://cloud-pd.bytedance.net/api/v1/cloud",
    bpm: "https://cloud-pd.bytedance.net/api/v1/bpm",
    event: "https://cloud-pd.bytedance.net/api/v1/cloud"
  },
  hl: {
    iam: "https://cloud-iam-hl.bytedance.net",
    page: "https://cloud-page-hl.bytedance.net",
    openapi: "https://cloud-openapi-hl.byted.org",
    galaxy: "https://galaxy-api-hl.bytedance.net",
    jwt: "https://cloud-hl.bytedance.net/auth/api",
    bytetree: "https://galaxy-api-hl.bytedance.net",
    api: "https://cloud-api-hl.bytedance.net",
    bpm: "https://bpm-hl.bytedance.net",
    event: "https://cloud-page-hl.bytedance.net"
  },
  lq: {
    iam: "https://cloud-iam-lq.bytedance.net",
    page: "https://cloud-page-lq.bytedance.net",
    openapi: "https://cloud-openapi-lq.byted.org",
    galaxy: "https://galaxy-api-lq.bytedance.net",
    jwt: "https://cloud-lq.bytedance.net/auth/api",
    bytetree: "https://galaxy-api-lq.bytedance.net",
    api: "https://cloud-api.bytedance.net",
    bpm: "https://bpm-lq.bytedance.net",
    event: "https://cloud-page-lq.bytedance.net"
  },
  us: {
    iam: "https://cloud-iam-us.bytedance.net",
    page: "https://cloud-page-i18n.bytedance.net",
    openapi: "https://cloud-openapi-us.bytedance.net",
    galaxy: "https://bytetree-us.tiktok-row.net",
    bytetree: "https://bytetree-us.tiktok-row.net",
    jwt: "https://cloud-us.bytedance.net/auth/api",
    api: "https://cloud-api.bytedance.net",
    bpm: "https://bpm-us.tiktok-row.net",
    event: "https://cloud-openapi-us.bytedance.net"
  },
  i18n: {
    iam: "https://cloud-iam.tiktok-row.net",
    page: "https://cloud-page-i18n.bytedance.net",
    openapi: "https://cloud-openapi-i18n.tiktok-row.net",
    galaxy: "https://bytetree-us.tiktok-row.net",
    jwt: "https://cloud-i18n.bytedance.net/auth/api",
    bytetree: "https://bytetree-us.tiktok-row.net",
    api: "https://cloud-api.bytedance.net",
    bpm: "https://bpm-i18n.tiktok-row.net",
    event: "https://cloud-openapi-i18n.tiktok-row.net"
  },
  "i18n-sg": {
    jwt: "https://cloud-i18n-sg.bytedance.net/auth/api",
    iam: "https://cloud-iam-sg.tiktok-row.net",
    page: "https://cloud-page-i18n.bytedance.net",
    api: "https://cloud-api.bytedance.net",
    openapi: "https://cloud-openapi-sg.tiktok-row.net",
    event: "https://cloud-openapi-sg.tiktok-row.net",
    bpm: "https://bpm-i18n-sg.tiktok-row.net",
    bytetree: "https://bytetree-sg.tiktok-row.net",
    galaxy: "https://bytetree-sg.tiktok-row.net"
  },
  "boe-i18n": {
    iam: "https://cloud-iam.bytedance.net",
    page: "https://cloud-page.bytedance.net",
    openapi: "https://cloud-openapi.bytedance.net",
    galaxy: "https://galaxy-api.bytedance.net",
    jwt: "https://cloud.bytedance.net/auth/api",
    bytetree: "https://galaxy-api.bytedance.net",
    api: "https://cloud-api.bytedance.net",
    bpm: "https://bpm-boe-i18n.bytedance.net",
    event: "https://cloud-page.bytedance.net"
  },
  tx: {
    iam: "https://cloud-iam-tx.bytedance.net",
    page: "https://cloud-page-tx.bytedance.net",
    openapi: "https://cloud-openapi-tx.bytedance.net",
    galaxy: "https://galaxy-api-tx.bytedance.net",
    jwt: "https://cloud-tx.bytedance.net/auth/api",
    bytetree: "https://galaxy-api-tx.bytedance.net",
    api: "https://cloud-api.bytedance.net",
    bpm: "https://bpm-tx.bytedance.net",
    event: "https://cloud-page-tx.bytedance.net"
  },
  "tx-tt": {
    iam: "https://cloud-iam-tx.tiktokd.net",
    page: "https://cloud-page-tx.tiktokd.net",
    openapi: "https://cloud-openapi-tx.tiktokd.net",
    galaxy: "https://bytetree-tx.tiktokd.net",
    jwt: "https://cloud-tx.tiktokd.net/auth/api",
    bytetree: "https://bytetree-tx.tiktokd.net",
    api: "https://cloud-api-tx.tiktokd.net",
    bpm: "https://bpm-tx.tiktokd.net",
    event: "https://cloud-page-tx.tiktokd.net"
  },
  xfl: {
    iam: "https://cloud-xfl.bytedance.net/web_api/iam",
    bpm: "https://cloud-xfl.bytedance.net/web_api/bpm",
    jwt: "https://cloud-xfl.bytedance.net/auth/api",
    page: "https://cloud-xfl.bytedance.net/web_api/cloud",
    openapi: "https://cloud-xfl.bytedance.net/web_api/cloud",
    api: "https://cloud-xfl.bytedance.net/web_api/cloud",
    event: "https://cloud-xfl.bytedance.net/web_api/cloud",
    bytetree: "https://cloud-xfl.bytedance.net/web_api/bytetree",
    galaxy: "https://cloud-xfl.bytedance.net/web_api/bytetree"
  },
  "sinf-xfl": {
    iam: "https://cloud.xfl.net/web_api/iam",
    bpm: "https://cloud.xfl.net/web_api/bpm",
    jwt: "https://cloud.xfl.net/auth/api",
    page: "https://cloud.xfl.net/web_api/cloud",
    openapi: "https://cloud.xfl.net/web_api/cloud",
    api: "https://cloud.xfl.net/web_api/cloud",
    event: "https://cloud.xfl.net/web_api/cloud",
    bytetree: "https://cloud.xfl.net/web_api/bytetree",
    galaxy: "https://cloud.xfl.net/web_api/bytetree"
  },
  "sinf-xfl-boe": {
    iam: "https://cloud.xfl.net/web_api/iam",
    jwt: "https://cloud.xfl.net/auth/api",
    page: "https://cloud.xfl.net/web_api/cloud",
    openapi: "https://cloud.xfl.net/web_api/cloud",
    api: "https://cloud.xfl.net/web_api/cloud",
    event: "https://cloud.xfl.net/web_api/cloud",
    bytetree: "https://cloud.xfl.net/web_api/bytetree",
    galaxy: "https://cloud.xfl.net/web_api/bytetree",
    bpm: "https://cloud-boe.xfl.net/web_api/bpm"
  },
  "sinf-boe": {
    iam: "https://cloud.sinf.net/web_api/iam",
    jwt: "https://cloud.sinf.net/auth/api",
    page: "https://cloud.sinf.net/web_api/cloud",
    openapi: "https://cloud.sinf.net/web_api/cloud",
    api: "https://cloud.sinf.net/web_api/cloud",
    event: "https://cloud.sinf.net/web_api/cloud",
    bytetree: "https://cloud.sinf.net/web_api/bytetree",
    galaxy: "https://cloud.sinf.net/web_api/bytetree",
    bpm: "https://cloud-boe.sinf.net/web_api/bpm"
  },
  sinf: {
    iam: "https://cloud.sinf.net/web_api/iam",
    jwt: "https://cloud.sinf.net/auth/api",
    page: "https://cloud.sinf.net/web_api/cloud",
    openapi: "https://cloud.sinf.net/web_api/cloud",
    api: "https://cloud.sinf.net/web_api/cloud",
    event: "https://cloud.sinf.net/web_api/cloud",
    bytetree: "https://cloud.sinf.net/web_api/bytetree",
    galaxy: "https://cloud.sinf.net/web_api/bytetree",
    bpm: "https://cloud.sinf.net/web_api/bpm"
  },
  sinfi18n: {
    iam: "https://cloud-i18n.sinf.net/web_api/iam",
    jwt: "https://cloud-i18n.sinf.net/auth/api",
    page: "https://cloud-i18n.sinf.net/web_api/cloud",
    openapi: "https://cloud-i18n.sinf.net/web_api/cloud",
    api: "https://cloud-i18n.sinf.net/web_api/cloud",
    event: "https://cloud-i18n.sinf.net/web_api/cloud",
    bytetree: "https://cloud-i18n.sinf.net/web_api/bytetree",
    galaxy: "https://cloud-i18n.sinf.net/web_api/bytetree",
    bpm: "https://cloud-i18n.sinf.net/web_api/bpm"
  },
  sinfonlinea: {
    iam: "https://cloud-sinfonlinea.sinf.net/web_api/iam",
    jwt: "https://cloud-sinfonlinea.sinf.net/auth/api",
    page: "https://cloud-sinfonlinea.sinf.net/web_api/cloud",
    openapi: "https://cloud-sinfonlinea.sinf.net/web_api/cloud",
    api: "https://cloud-sinfonlinea.sinf.net/web_api/cloud",
    event: "https://cloud-sinfonlinea.sinf.net/web_api/cloud",
    bytetree: "https://cloud-sinfonlinea.sinf.net/web_api/bytetree",
    galaxy: "https://cloud-sinfonlinea.sinf.net/web_api/bytetree",
    bpm: "https://cloud-sinfonlinea.sinf.net/web_api/bpm"
  },
  volcgroup: {
    iam: "https://cloud.volcgroup.com/web_api/iam",
    jwt: "https://cloud.volcgroup.com/auth/api",
    page: "https://cloud.volcgroup.com/web_api/cloud",
    openapi: "https://cloud.volcgroup.com/web_api/cloud",
    api: "https://cloud.volcgroup.com/web_api/cloud",
    event: "https://cloud.volcgroup.com/web_api/cloud",
    bytetree: "https://cloud.volcgroup.com/web_api/bytetree",
    galaxy: "https://cloud.volcgroup.com/web_api/bytetree",
    bpm: "https://cloud.volcgroup.com/web_api/bpm"
  },
  "volcgroup-boe": {
    iam: "https://vgcloud-boe.bytedance.net/web_api/iam",
    jwt: "https://vgcloud-boe.bytedance.net/auth/api",
    page: "https://vgcloud-boe.bytedance.net/web_api/cloud",
    openapi: "https://vgcloud-boe.bytedance.net/web_api/cloud",
    api: "https://vgcloud-boe.bytedance.net/web_api/cloud",
    event: "https://vgcloud-boe.bytedance.net/web_api/cloud",
    bytetree: "https://vgcloud-boe.bytedance.net/web_api/bytetree",
    galaxy: "https://vgcloud-boe.bytedance.net/web_api/bytetree",
    bpm: "https://vgcloud-boe.bytedance.net/web_api/bpm"
  },
  "i18n-bd": {
    iam: "https://cloud.byteintl.net/api/v1/iam",
    page: "https://cloud.byteintl.net/api/v1/cloud",
    openapi: "https://cloud.byteintl.net/api/v1/cloud",
    galaxy: "https://cloud.byteintl.net/api/v1/bytetree",
    jwt: "https://cloud.byteintl.net/auth/api",
    bytetree: "https://cloud.byteintl.net/api/v1/bytetree",
    api: "https://cloud.byteintl.net/api/v1/cloud",
    bpm: "https://cloud.byteintl.net/api/v1/bpm",
    event: "https://cloud.byteintl.net/api/v1/cloud"
  },
  "i18n-bd-de": {
    iam: "https://cloud-de.byteintl.net/api/v1/iam",
    page: "https://cloud-de.byteintl.net/api/v1/cloud",
    openapi: "https://cloud-de.byteintl.net/api/v1/cloud",
    galaxy: "https://cloud-de.byteintl.net/api/v1/bytetree",
    jwt: "https://cloud-de.byteintl.net/auth/api",
    bytetree: "https://cloud-de.byteintl.net/api/v1/bytetree",
    api: "https://cloud-de.byteintl.net/api/v1/cloud",
    bpm: "https://cloud-de.byteintl.net/api/v1/bpm",
    event: "https://cloud-de.byteintl.net/api/v1/cloud"
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  rowApiConfig
});
